export const Images = {
  companyLogo: require("./images/company-logo.png"),
  companyLogoWhite: require("./images/company-logo-white.png").default,
  selectArrow: require("./images/selectArrow.svg").default,
  checkBox: require("./images/checkbox.svg").default,
  checkBoxSelected: require("./images/checkBoxSelected.svg").default,
  dropDownArrow: require("./images/dropdownIcon.svg").default,
  filefloder: require("./images/files-and-folders.svg").default,
};
